import type { CSSProperties, ReactNode } from "react";
import styles from "./TwoByStatTable.module.scss";

interface Props extends CSSProperties {
  children: ReactNode;
}

export default function TwoByStatTable({ children, ...style }: Props) {
  return (
    <div style={style} className={styles.wrapper}>
      {children}
    </div>
  );
}
